import React, { useEffect } from 'react';
import { getNameClient } from './../../helpers/nameClient';
import { useGetKeySize } from './../../helpers/imageRezise';
import { useSelector } from 'react-redux';
import 'flatpickr/dist/themes/material_blue.css';
//import Breadcrumbs
import { Container } from 'reactstrap';
//import Components
import '../Dashboard/index.scss';
import Swal from 'sweetalert2';
import { updateStyleDocument } from '../../helpers/tools_helper';
import imgHome from './../../assets/images/home.png';

const Home = () => {
    //const initialFilterState: any[] | (() => any[]) = [];
    // const [isLoading, setIsLoading] = useState(true);
    const { isLoading } = useSelector((state: any) => state.Dashboard);
    useEffect(() => {
        let theme = {};
        const brand = localStorage.getItem('brand');
        if (brand) {
            theme = JSON.parse(brand).theme;
        }
        updateStyleDocument();
        if (theme === null || theme === undefined) {
            setTimeout(() => {
                updateStyleDocument();
            }, 3000);
        }
    }, []);

    const hideProgress = () => {
        Swal.close();
    };

    const brandLocalS = JSON.parse(localStorage.getItem('brand') || '');
    const usePageTitle = (title: string) => {
        const defaultTitle = 'app-name';
        useEffect(() => {
            document.title = title || defaultTitle;
        }, [defaultTitle, title]);
    };
    usePageTitle('Home | ' + getNameClient());
    return (
        <React.Fragment>
            <div key={useGetKeySize()} className="page-content imageHomeSize background_Login_Home w-100" style={{height: window.innerHeight,backgroundImage: `url('${brandLocalS.urlHome || imgHome}')` }}/>

        </React.Fragment>
    );
};

export default Home;